import { render, staticRenderFns } from "./rulesSetting.vue?vue&type=template&id=216b59b0&scoped=true&"
import script from "./rulesSetting.vue?vue&type=script&lang=js&"
export * from "./rulesSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216b59b0",
  null
  
)

export default component.exports